<template>
  <common-query :query="query" @query="onClickQuery">
    <el-form-item label="通道号">
      <el-input v-model="query.id" />
    </el-form-item>
    <el-form-item label="通道全称">
      <el-input v-model="query.passagewayName" placeholder="请输入" />
    </el-form-item>
    <el-form-item label="渠道简称">
      <el-input v-model="query.passagewayAbbreviationName" />
    </el-form-item>
    <el-form-item label="产品名称">
      <el-input v-model="query.productName" />
    </el-form-item>
    <el-form-item label="通讯方式">
      <common-select
        v-model="query.communicationSt"
        :list="communicationStList"
      />
    </el-form-item>
    <el-form-item label="通道类型">
      <common-select v-model="query.channelType" :list="channelTypeList" />
    </el-form-item>
    <el-form-item label="通道来源">
      <common-select
        v-model="query.sourceChannelType"
        :list="sourceChannelTypeList"
      />
    </el-form-item>
    <el-form-item label="通道状态">
      <common-select v-model="query.status" :list="channelStatus" />
    </el-form-item>
    <el-form-item label="建档时间" class="auto-width">
      <date-picker v-model="query.createTimeBegin" time />
      <span class="middle-text">至</span>
      <date-picker v-model="query.createTimeEnd" time />
    </el-form-item>
    <!-- <el-form-item label="日切时间" class="auto-width">
      <time-picker v-model="query.cutTime" />
      <span class="middle-text">至</span>
      <time-picker v-model="query.cutTimeEnd" />
    </el-form-item> -->
  </common-query>
</template>

<script>
export default {
  props: {
    query: {
      type: Object,
      default() {
        return {}
      },
      comment: '查询数据条件'
    },
    communicationStList: Array, // 通讯方式
    channelTypeList: Array, // 通道类型
    sourceChannelTypeList: Array, // 通道来源
    paymentMark: Array,
    channelStatus: Array
  },

  methods: {
    onClickQuery() {
      this.$emit('query', this.query)
    }
  }
}
</script>

